export const ManualDriverInvoice = {
  CANDIDATES_ENTITY_NAME: 'pagedManualDriverInvoiceCandidates',
  // Must match ManualDriverInvoiceConstants.MaxBatchSize on the server
  MAX_BATCH_SIZE: 20,
}
